var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAzure = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 26,
    viewBox: "0 0 110 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6621_201)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 16.9574V7.57367H31.6181C34.9536 7.57367 36.6273 9.10015 36.6273 12.1531C36.6273 13.5968 36.161 14.7683 35.2405 15.6439C34.308 16.5196 33.0767 16.9574 31.5105 16.9574H29ZM30.1118 8.56766V15.9634H31.5225C32.7658 15.9634 33.7342 15.6321 34.4276 14.9694C35.121 14.3068 35.4677 13.3719 35.4677 12.1649C35.4677 9.76281 34.1765 8.55582 31.5942 8.55582H30.1118V8.56766Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7405 10.2613L40.6322 18.0357C40.0823 19.4202 39.2933 20.1183 38.2891 20.1183C38.0021 20.1183 37.775 20.0947 37.5837 20.0355V19.077C37.8228 19.1598 38.026 19.1953 38.2293 19.1953C38.7792 19.1953 39.1857 18.8759 39.4606 18.225L39.9986 16.9589L37.3566 10.2731H38.564L40.3931 15.4324C40.417 15.5034 40.4649 15.6691 40.5366 15.9412H40.5725C40.5964 15.8347 40.6442 15.6691 40.704 15.4442L42.6287 10.2731H43.7405V10.2613Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.519 16.9563H49.4311V13.1342C49.4311 11.7142 48.9051 11.0042 47.853 11.0042C47.3151 11.0042 46.8608 11.2054 46.5021 11.6077C46.1435 12.0101 45.9642 12.5189 45.9642 13.1342V16.9563H44.8763V10.2588H45.9642V11.3711H45.9881C46.5021 10.5191 47.2433 10.1049 48.2117 10.1049C48.9529 10.1049 49.5148 10.3416 49.9093 10.8149C50.3038 11.2882 50.4951 11.9746 50.4951 12.8621V16.9563H50.519Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.405 16.9571H56.3171V15.9158H56.2932C55.827 16.7205 55.1216 17.1228 54.213 17.1228C53.5435 17.1228 53.0056 16.9453 52.635 16.5903C52.2644 16.2353 52.0611 15.7738 52.0611 15.1821C52.0611 13.9278 52.8023 13.206 54.2967 12.993L56.3291 12.709C56.3291 11.573 55.8628 11.005 54.9303 11.005C54.1174 11.005 53.3762 11.2772 52.7187 11.8334V10.721C53.3881 10.3069 54.1533 10.0939 55.014 10.0939C56.604 10.0939 57.405 10.9222 57.405 12.5907V16.9571ZM56.3291 13.561L54.6912 13.7858C54.1891 13.8568 53.8066 13.9752 53.5555 14.1527C53.3044 14.3302 53.1729 14.6378 53.1729 15.0875C53.1729 15.4188 53.2925 15.6791 53.5316 15.8921C53.7707 16.1051 54.0815 16.1998 54.476 16.1998C55.014 16.1998 55.4563 16.0105 55.803 15.6436C56.1497 15.2768 56.3291 14.8035 56.3291 14.2237V13.561Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0612 16.9563H67.9853V13.1105C67.9853 12.3651 67.8657 11.8326 67.6386 11.5012C67.4114 11.1699 67.0169 11.0042 66.467 11.0042C66.0007 11.0042 65.6062 11.2172 65.2834 11.6314C64.9606 12.0456 64.7933 12.5544 64.7933 13.1342V16.9563H63.7054V12.9804C63.7054 11.6669 63.1913 11.0042 62.1632 11.0042C61.685 11.0042 61.2905 11.2054 60.9916 11.5959C60.6808 11.9864 60.5253 12.5071 60.5253 13.1342V16.9563H59.4374V10.2588H60.5253V11.3237H60.5493C61.0275 10.5072 61.7328 10.1049 62.6533 10.1049C63.1196 10.1049 63.5141 10.2351 63.8608 10.4836C64.2075 10.7439 64.4346 11.0752 64.5661 11.4894C65.0682 10.5664 65.8214 10.1049 66.8137 10.1049C68.308 10.1049 69.0493 11.0161 69.0493 12.8384V16.9563H69.0612Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6674 8.55605C71.4761 8.55605 71.3088 8.48505 71.1773 8.35488C71.0458 8.22472 70.974 8.05905 70.974 7.85789C70.974 7.65672 71.0458 7.49106 71.1773 7.36089C71.3088 7.23073 71.4761 7.15973 71.6674 7.15973C71.8707 7.15973 72.038 7.23073 72.1695 7.36089C72.313 7.49106 72.3728 7.65672 72.3728 7.85789C72.3728 8.04722 72.301 8.21288 72.1695 8.34305C72.038 8.48505 71.8707 8.55605 71.6674 8.55605ZM72.1934 16.9576H71.1055V10.26H72.1934V16.9576Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0076 16.6495C78.4816 16.9571 77.8719 17.111 77.1546 17.111C76.1863 17.111 75.4092 16.8033 74.8234 16.1761C74.2257 15.549 73.9387 14.7443 73.9387 13.7622C73.9387 12.6617 74.2615 11.7742 74.8951 11.0997C75.5287 10.4252 76.3895 10.0939 77.4535 10.0939C78.0512 10.0939 78.5773 10.2004 79.0316 10.4252V11.5257C78.5294 11.1825 77.9915 11.005 77.4176 11.005C76.7242 11.005 76.1624 11.2535 75.72 11.7387C75.2777 12.2238 75.0505 12.8747 75.0505 13.6675C75.0505 14.4485 75.2538 15.0756 75.6722 15.5253C76.0906 15.975 76.6525 16.2116 77.3459 16.2116C77.9317 16.2116 78.4936 16.0223 79.0076 15.6318V16.6495Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2391 16.7078V15.56C80.8249 15.986 81.4824 16.2108 82.1878 16.2108C83.1442 16.2108 83.6104 15.8913 83.6104 15.2642C83.6104 15.0867 83.5746 14.9329 83.4909 14.8145C83.4072 14.6844 83.2996 14.5779 83.1561 14.4832C83.0127 14.3885 82.8573 14.3057 82.666 14.2229C82.4747 14.1519 82.2715 14.069 82.0563 13.9862C81.7574 13.8679 81.4944 13.7495 81.2672 13.6312C81.0401 13.5129 80.8488 13.3709 80.6934 13.2289C80.538 13.075 80.4304 12.9094 80.3467 12.7201C80.275 12.5307 80.2272 12.3059 80.2272 12.0456C80.2272 11.7261 80.2989 11.4539 80.4423 11.2054C80.5858 10.9569 80.7771 10.7557 81.0281 10.6019C81.2792 10.4481 81.5422 10.3179 81.853 10.2351C82.1639 10.1523 82.4866 10.1049 82.8094 10.1049C83.3952 10.1049 83.9212 10.1996 84.3875 10.4007V11.4894C83.8854 11.1699 83.3115 11.0042 82.666 11.0042C82.4627 11.0042 82.2834 11.0279 82.116 11.0752C81.9487 11.1226 81.8172 11.1817 81.6976 11.2646C81.5781 11.3474 81.4944 11.4421 81.4227 11.5604C81.3629 11.6787 81.327 11.8089 81.327 11.9391C81.327 12.1166 81.3629 12.2586 81.4227 12.3769C81.4824 12.4952 81.5781 12.6017 81.6976 12.6964C81.8172 12.7911 81.9726 12.8739 82.1519 12.9449C82.3312 13.0159 82.5345 13.0987 82.7497 13.1815C83.0485 13.2999 83.3235 13.4064 83.5506 13.5365C83.7897 13.6549 83.993 13.7969 84.1603 13.9389C84.3277 14.0927 84.4592 14.2584 84.5429 14.4595C84.6385 14.6607 84.6744 14.8855 84.6744 15.1577C84.6744 15.489 84.6027 15.773 84.4473 16.0215C84.3038 16.27 84.1006 16.4712 83.8615 16.625C83.6104 16.7907 83.3355 16.909 83.0127 16.98C82.6899 17.0628 82.3551 17.0983 81.9965 17.0983C81.3509 17.1102 80.7532 16.98 80.2391 16.7078Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8749 16.6164V15.4567C90.5204 15.9656 91.2497 16.2141 92.0746 16.2141C92.7321 16.2141 93.2581 16.0484 93.6527 15.7289C94.0472 15.3976 94.2384 14.9597 94.2384 14.4036C94.2384 13.1729 93.3538 12.5694 91.5964 12.5694H90.8193V11.6583H91.5605C93.1266 11.6583 93.9037 11.0785 93.9037 9.93064C93.9037 8.86565 93.306 8.33316 92.1105 8.33316C91.441 8.33316 90.8193 8.55799 90.2216 9.00765V7.96633C90.8313 7.61134 91.5486 7.43384 92.3735 7.43384C93.1745 7.43384 93.8081 7.64684 94.2863 8.061C94.7645 8.47516 95.0036 9.01949 95.0036 9.67031C95.0036 10.901 94.37 11.6938 93.1027 12.0488V12.0724C93.7842 12.1434 94.3341 12.3801 94.7286 12.7824C95.1351 13.1848 95.3383 13.7054 95.3383 14.3089C95.3383 15.1491 95.0275 15.8354 94.4178 16.3442C93.8081 16.8649 93.0071 17.1252 92.0029 17.1252C91.1182 17.1134 90.4009 16.9477 89.8749 16.6164Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.475 7.67946V8.69711C101.985 8.44861 101.471 8.31845 100.933 8.31845C100.096 8.31845 99.4149 8.68528 98.9128 9.43077C98.4107 10.1763 98.1596 11.1702 98.1596 12.4127H98.1835C98.6259 11.5252 99.3432 11.0874 100.347 11.0874C101.172 11.0874 101.83 11.3477 102.32 11.8802C102.81 12.4009 103.049 13.1109 103.049 13.9865C103.049 14.9095 102.774 15.655 102.212 16.2349C101.65 16.8147 100.945 17.1105 100.072 17.1105C99.116 17.1105 98.3748 16.7318 97.8368 15.9864C97.2989 15.2409 97.0239 14.1877 97.0239 12.8269C97.0239 11.1821 97.3825 9.8686 98.0879 8.88644C98.7932 7.90429 99.7377 7.41913 100.897 7.41913C101.567 7.41913 102.093 7.50196 102.475 7.67946ZM100.108 11.9986C99.5464 11.9986 99.0921 12.1879 98.7454 12.5666C98.3987 12.9452 98.2194 13.3831 98.2194 13.8919C98.2194 14.5309 98.3868 15.0752 98.7334 15.5367C99.0801 15.9864 99.5344 16.223 100.108 16.223C100.658 16.223 101.101 16.0219 101.435 15.6314C101.77 15.2409 101.937 14.732 101.937 14.1285C101.937 13.4659 101.782 12.9452 101.459 12.5666C101.148 12.1879 100.694 11.9986 100.108 11.9986Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M104.687 16.7326V15.5966C105.333 16.0107 105.99 16.2237 106.66 16.2237C107.329 16.2237 107.867 16.0344 108.274 15.6557C108.68 15.2771 108.883 14.7801 108.883 14.1648C108.883 13.5494 108.668 13.0643 108.25 12.7211C107.831 12.3779 107.233 12.2004 106.456 12.2004C106.193 12.2004 105.691 12.2241 104.974 12.2833V7.57367H109.565V8.54399H106.002V11.2893C106.289 11.2775 106.564 11.2656 106.803 11.2656C107.819 11.2656 108.596 11.5141 109.158 12.0229C109.708 12.5318 109.995 13.2181 109.995 14.0938C109.995 15.0049 109.696 15.7267 109.098 16.2829C108.501 16.8391 107.688 17.1112 106.648 17.1112C105.775 17.1112 105.117 16.9811 104.687 16.7326Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6621_201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6621_201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V26H26V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6621_201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6621_201",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 20,
    height: 26
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2084 8.40858C22.2084 7.26402 21.4888 6.243 20.4109 5.85804L4.69769 0.246218C3.99219 -0.0057489 3.25 0.517282 3.25 1.26644V9.79907C3.25 10.2569 3.53781 10.6653 3.96898 10.8193L11.0106 13.3342C11.7161 13.5861 12.4583 13.0631 12.4583 12.3139V7.41457C12.4583 7.03611 12.8366 6.77429 13.1908 6.9076L15.0373 7.6025C16.0928 7.99973 16.7917 9.00948 16.7917 10.1373V12.2708L8.83653 15.1775C8.40924 15.3336 8.125 15.7401 8.125 16.195V24.7216C8.125 25.4741 8.87334 25.9974 9.58013 25.7391L20.4295 21.7749C21.4977 21.3846 22.2083 20.3684 22.2083 19.2311L22.2084 8.40858Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6621_201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 -0.270813L22.2084 6.49997V15.7962C22.2084 16.5454 21.4663 17.0684 20.7608 16.8165L16.7917 15.3994V10.1357C16.7917 9.00739 16.0921 7.99727 15.0359 7.60042L13.1905 6.90706C12.8363 6.77399 12.4583 7.03578 12.4583 7.41411V13.8512L3.25 10.5625V-0.270813Z",
    fill: "url(#paint0_linear_6621_201)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6621_201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2083 8.50415C22.2083 9.64149 21.4977 10.6597 20.4295 11.05L8.125 15.5458V26.3792L22.2083 21.2333V8.50415Z",
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6621_201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2083 8.93744C22.2083 10.0748 21.4977 11.0929 20.4295 11.4832L8.125 15.9791V26.8125L22.2083 21.6666V8.93744Z",
    fill: "black",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.2083 8.39581C22.2083 9.53315 21.4977 10.5513 20.4295 10.9416L8.125 15.4375V26.2708L22.2083 21.125V8.39581Z",
    fill: "url(#paint1_linear_6621_201)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.2083 8.39581C22.2083 9.53315 21.4977 10.5513 20.4295 10.9416L8.125 15.4375V26.2708L22.2083 21.125V8.39581Z",
    fill: "url(#paint2_linear_6621_201)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.792 12.2742L12.4562 13.8604L12.4562 20.2136C12.4562 20.5921 12.8345 20.8539 13.1887 20.7205L15.0378 20.0246C16.0932 19.6273 16.792 18.6176 16.792 17.4899V12.2742Z",
    fill: "#B0ADFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6621_201",
    x: 7.325,
    y: 7.70415,
    width: 15.6833,
    height: 19.475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur_6621_201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6621_201",
    x: 0.125,
    y: 0.937439,
    width: 30.0833,
    height: 33.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6621_201"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6621_201",
    x1: 10.3039,
    y1: -0.270813,
    x2: 15.345,
    y2: 12.9251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B53CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7252AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6621_201",
    x1: 17.3706,
    y1: 25.3208,
    x2: 17.3706,
    y2: 9.59162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2266E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE7FE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6621_201",
    x1: 22.2083,
    y1: 15.3795,
    x2: 16.8124,
    y2: 15.3795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287843,
    stopColor: "#94B9FF",
    stopOpacity: 0.523646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#538FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6621_201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6621_201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAzure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/azure.5c621db985855f8ba88888e60a9cb74f.svg";